import { createSelector } from 'reselect';
var selectState = function (state) { return state.get('gender'); };
export var selectDefaultGender = createSelector(selectState, function (state) {
    return state.get('defaultGender');
});
export var selectGender = createSelector(selectState, function (state) {
    return state.get('gender');
});
export var selectCurrentGender = createSelector(selectState, function (state) { return state.get('gender') || state.get('defaultGender'); });
